import React from 'react'
import Button from "../../../gd-components/buttons/gd-button/gd-button-ui5-new"

// const debug = "ModalHighPerformance"
const debug = false

export default function ModalHighPerformance() {

    debug && console.log(debug, 'render')

    const closeModal = (e: React.MouseEvent) => {
        gd.modal.hide()
    }

    return (
        <>
            <div className="header w-100-percent">
                <div className="i5-delete" onClick={closeModal}/>
            </div>
            <div className="modal-content flex-column-center-top">
                <div className="flex-row-center-center">
                    <img className="logo" src="/app/web/skin/common/svg/speedometer.svg"/>
                </div>

                <div className="flex-row-center-center title m-t-30 h-30">High Performance Mode Activated</div>

                <div className="flex-row-left-top m-t-30">
                    <div className="flex-column-left-top w-24 flex-no-shrink m-t-2">
                        <div className="ui5-ico-14 i5-done green"/>
                    </div>
                    <div className="flex-row-left-top ui5-txt-less-important lh-14em">
                        Right now, you’re in High Performance Mode, which applies when you have a large number of tasks.
                    </div>
                </div>

                <div className="flex-row-left-top m-t-30">
                    <div className="flex-column-left-top w-24 flex-no-shrink m-t-2">
                        <div className="ui5-ico-14 i5-action-required"/>
                    </div>
                    <div className="flex-row-left-top ui5-txt-less-important lh-14em">
                        In High Performance Mode, exporting to CSV/PDF is unavailable. If you want to do this, switch to
                        Default Mode.
                    </div>
                </div>
            </div>

            <div className="actions flex-row-center-center m-t-50">
                <Button className="w-125"
                        type="primary"
                        size="36"
                        label="OK"
                        onClick={closeModal}/>
            </div>
        </>
    )

}